import { useTranslation } from 'react-i18next'

const primary = 'h-9 w-full rounded-lg bg-blue-600 px-3 text-sm font-semibold text-white disabled:opacity-40'

// The left column: "+ Add new" on top, the entries, and the n/limit counter.
export default function QuickAnswerList({
  items, selectedId, newDraftOpen, newDraftTitle, maxEntries, canWrite, onSelect, onAdd,
}) {
  const { t } = useTranslation()
  const full = items.length >= maxEntries
  return (
    <nav aria-label={t('quickAnswer.list.title')} className="flex flex-col gap-2">
      {canWrite && (
        <button type="button" className={primary} disabled={full} onClick={onAdd}>
          {t('quickAnswer.list.add')}
        </button>
      )}
      <p className="text-xs text-slate-500" data-testid="qa-count">
        {t('quickAnswer.list.count', { count: items.length, max: maxEntries })}
      </p>
      {full && canWrite && (
        <p role="status" className="rounded-lg border border-amber-200 bg-amber-50 p-2 text-xs text-amber-800">
          {t('quickAnswer.list.limitReached', { max: maxEntries })}
        </p>
      )}
      <ul className="flex flex-col gap-1">
        {newDraftOpen && (
          <li>
            <button type="button" aria-current={selectedId === 'new' ? 'true' : undefined}
              onClick={() => onSelect('new')}
              className={`w-full rounded-lg border p-2 text-left text-sm ${selectedId === 'new' ? 'border-blue-500 bg-blue-50' : 'border-dashed border-slate-300 bg-white'}`}>
              <span className="block truncate font-medium text-slate-900">{newDraftTitle || t('quickAnswer.list.newDraft')}</span>
              {newDraftTitle && <span className="text-xs text-slate-500">{t('quickAnswer.list.newDraft')}</span>}
            </button>
          </li>
        )}
        {items.map((item) => (
          <li key={item.id}>
            <button type="button" aria-current={selectedId === item.id ? 'true' : undefined}
              onClick={() => onSelect(item.id)}
              className={`flex w-full items-center gap-2 rounded-lg border p-2 text-left text-sm ${selectedId === item.id ? 'border-blue-500 bg-blue-50' : 'border-slate-200 bg-white'}`}>
              <span role="img" aria-label={item.enabled ? t('quickAnswer.list.on') : t('quickAnswer.list.off')}
                className={`h-2.5 w-2.5 shrink-0 rounded-full ${item.enabled ? 'bg-green-500' : 'bg-slate-300'}`} />
              <span className="min-w-0 flex-1 truncate font-medium text-slate-900">{item.title || t('quickAnswer.list.untitled')}</span>
              {(item.attachments || []).length > 0 && (
                <span className="shrink-0 text-xs text-slate-400">{t('quickAnswer.list.attachments', { count: item.attachments.length })}</span>
              )}
            </button>
          </li>
        ))}
      </ul>
      {items.length === 0 && !newDraftOpen && (
        <p className="rounded-lg border border-slate-200 bg-white p-3 text-sm text-slate-500">{t('quickAnswer.list.empty')}</p>
      )}
    </nav>
  )
}
